module.exports = __webpack_public_path__ + "img/485932_tip_img.39e817f8.png";